// extracted by mini-css-extract-plugin
export var actionButton = "_c3-0";
export var fileInput = "_c3-2";
export var paperclip = "_c3-1";